import { makeStyles, useTheme, createStyles } from "@material-ui/core";
import React from "react";
import SwipeableViews from "react-swipeable-views";
import Box from "@mui/material/Box";
import { ArrowCarousel } from "./ArrowCarousel";
import classNames from "classnames";
import { serverConfig } from "../../../../utils/config";
import { CameraAltOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
const Env = serverConfig;
export const PreviewImage = (props: any) => {
    const theme = useTheme();
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = props?.photos?.length ?? 1;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };
    const havePrevious = !(activeStep === 0);
    const haveNext = !(activeStep === maxSteps - 1);

    return (
        <div className={classes.my_carousel}>
            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                style={{ height: "100%" }}
                className={classes.swipeable}
            >
                {props.photos &&
                    props.photos.map((step: any, index: any) => (
                        <div style={{ height: "100%", maxHeight: 400 }}>
                            {
                                <Box
                                    className={classes.imageContainer}
                                    style={{
                                        backgroundImage: `url("${`${Env.ApiRoot}/images/properties/${step.filename}`}")`,
                                    }}
                                    position="relative"
                                >
                                    <Stack
                                        className={
                                            classes.previewCountContainer
                                        }
                                        direction="row"
                                        padding={1}
                                        left={5}
                                        bottom={16}
                                    >
                                        <CameraAltOutlined
                                            sx={{
                                                width: 15,
                                                height: 15,
                                                color: "#fff",
                                                marginRight: 1,
                                            }}
                                        />
                                        <Typography className={classes.nombre}>
                                            {maxSteps}
                                        </Typography>
                                    </Stack>
                                    {props.isExeptional && (
                                        <Box
                                            className={
                                                classes.exeptionContainer
                                            }
                                        >
                                            <svg
                                                width="55.5"
                                                height="10"
                                                viewBox="0 0 55.5 10"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0 0L210 5.5L221.5 30L0 40V0Z"
                                                    fill="#890608"
                                                    fillOpacity="0.86"
                                                />
                                            </svg>
                                            <Box
                                                className={
                                                    classes.exeptionContainerText
                                                }
                                            >
                                                {props.dealText}
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            }
                        </div>
                    ))}
            </SwipeableViews>
            {havePrevious && (
                <div className={classNames(classes.previous, "prev_next")}>
                    <ArrowCarousel direction="left" onClick={handleBack} />
                </div>
            )}
            {haveNext && (
                <div className={classNames(classes.next, "prev_next")}>
                    <ArrowCarousel direction="right" onClick={handleNext} />
                </div>
            )}
        </div>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        swipeable: {
            "& > .react-swipeable-view-container": {
                height: "100% !important",
            },
        },
        previewCountContainer: {
            borderRadius: 8,
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "#fff",
            bottom: "5px !important",
        },
        nombre: {
            marginBottom: 40,
            fontSize: 10,
        },
        previous: {
            position: "absolute",
            top: "30%",
            left: 5,
            opacity: 0,
            transition: "opacity .5s, background .2s ease-in-out",
            background: "#890608",
            borderRadius: "50%",
            border: "solid 1px white",
            "&:hover": {
                background: "#EA7606",
            },
        },
        exeptionContainer: {
            position: "absolute",
            left: 0,
            top: 22,
        },
        imageContainer: {
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
        },
        next: {
            position: "absolute",
            top: "30%",
            right: 5,
            opacity: 0,
            transition: "opacity .5s, background .2s ease-in-out",
            background: "#890608",
            borderRadius: "50%",
            border: "solid 1px white",
            "&:hover": {
                background: "#EA7606",
            },
        },
        photo: {
            position: "absolute",
            bottom: 5,
            left: 5,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: 4,
            padding: "0 4px",
            display: "flex",
            alignItems: "center",
        },
        exeptionContainerText: {
            top: 0,
            left: 0,
            position: "absolute",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            fontWeight: "bold",
            color: "#fff",
            marginTop: 10,
            marginLeft: 18,
        },
        my_carousel: {
            height: "100%",
            position: "relative",
            "&:hover": {
                "& .prev_next": {
                    opacity: 1,
                },
            },
        },
    })
);
